import { ReactNode } from 'react';

import { Close, Fullscreen, FullscreenExit } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

type DialogHeaderActionsProps = {
	isMaximized: boolean;
	onToggleMaximized: () => void;
	onClose: () => void;
	closeDisabled?: boolean;
	iconButtonSx?: SxProps<Theme>;
	children?: ReactNode;
};

export default function DialogHeaderActions({
	isMaximized,
	onToggleMaximized,
	onClose,
	closeDisabled = false,
	iconButtonSx,
	children,
}: DialogHeaderActionsProps) {
	const maximizeLabel = isMaximized ? 'Restore dialog size' : 'Maximize dialog';

	return (
		<Stack direction="row" spacing={0.5} alignItems="center">
			{children}
			<Tooltip title={maximizeLabel}>
				<IconButton aria-label={maximizeLabel} onClick={onToggleMaximized} size="small" sx={iconButtonSx}>
					{isMaximized ? <FullscreenExit fontSize="small" /> : <Fullscreen fontSize="small" />}
				</IconButton>
			</Tooltip>
			<Tooltip title="Close dialog">
				<IconButton aria-label="Close dialog" onClick={onClose} size="small" disabled={closeDisabled} sx={iconButtonSx}>
					<Close fontSize="small" />
				</IconButton>
			</Tooltip>
		</Stack>
	);
}
